import * as React from "react";
import { InfoWindowF } from "@react-google-maps/api";
import type { Zone } from "../../../types";
import { Icon, Badge, Heading } from "@ogt/ui";

type CityZoneInfoWindowProps = {
  zone: Zone;
  position: google.maps.LatLngLiteral;
  onClose?: () => void;
};

export default function CityZoneInfoWindow({
  zone,
  position,
  onClose,
}: CityZoneInfoWindowProps) {
  const label = zone.name || "Stadszon";

  return (
    <InfoWindowF
      position={position}
      onCloseClick={onClose}
      options={{
        disableAutoPan: false,
        pixelOffset: new google.maps.Size(0, -12),
      }}
    >
      <div className="pt-0 pl-4 pr-6 pb-6 min-w-[180px] text-sm leading-snug bg-[var(--semantic-color-bg-primary)]">
        <div className="flex gap-2 mb-4 items-center">
          <Badge
            icons={[<Icon key="zone:land-plot" name="zone:land-plot" />]}
            shape="default"
            state="default"
            variant="red"
          ></Badge>
          <Heading
            as="h3"
            className="text-[var(--semantic-color-text-secondary)] mb-0"
          >
            {label}
          </Heading>
        </div>
        <Heading as="h4" className=" text-[var(--semantic-color-text-primary)]">
          Zon för stadstrafik.
        </Heading>
      </div>
    </InfoWindowF>
  );
}
